import React from "react";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";

import axios from "axios";

const GoogleAuth = ({ isOpen, setIsOpen }) => {
  const responseMessage = async (response) => {
    const data = await jwtDecode(response.credential);
    if (data?.email_verified) {
      localStorage.setItem("name", data?.given_name + " " + data?.family_name);
      localStorage.setItem("email", data?.email);

      axios
        .post(`${process.env.REACT_APP_API_URL}/user/google-login`, {
          data: data,
        })
        .then((response) => {
          localStorage.setItem(
            "userID",
            response?.data?.message?.result_email?.email,
          );
          localStorage.setItem(
            "candidate_id",
            response.data.message.candidate_id,
          );
          Cookies.set("authToken", response.data.message.token);
          if (!response?.data?.message?.isResume) {
            setIsOpen((prev) => ({
              ...prev,
              isResumeOpen: true,
            }));
          } else {
            window.location.href = "/authPage/jobdetails/openposition";
          }
        });
    }
  };
  const errorMessage = (error) => {
    console.log("Google Error", error);
  };

  const google_client_id = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  return (
    <div
      className="opacity-0 overflow-hidden"
      style={{ width: "115px", position: "relative" }}
    >
      <GoogleOAuthProvider clientId={google_client_id}>
        <GoogleLogin onSuccess={responseMessage} onError={errorMessage} />
      </GoogleOAuthProvider>
    </div>
  );
};

export default GoogleAuth;
